module.exports = __webpack_public_path__ + "img/contact1.1738b6ee.png";